/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-05-21 09:46:44
 * @LastEditors: 杨华
 * @Description:
 * @LastEditTime: 2020-07-06 16:19:14
 */
export default [
    {
        moduleName: "系统配置",
        icon: "",
        menuId: "1",
        children: [
            {
                parentName: "系统配置",
                moduleName: "权限管理",
                icon: "",
                menuId: "1-1",
                url: "/homepage/systemconfig/role",
            },
            {
                parentName: "系统配置",
                moduleName: "用户管理",
                icon: "",
                menuId: "1-2",
                url: "/homepage/systemconfig/user",
            },
            {
                parentName: "系统配置",
                moduleName: "日志管理",
                icon: "",
                menuId: "1-3",
                url: "/homepage/systemconfig/log",
            },
            {
                parentName: "系统配置",
                moduleName: "在线用户",
                icon: "",
                menuId: "1-4",
                url: "/homepage/systemconfig/onlineuser",
            },
            {
                parentName: "系统配置",
                moduleName: "典表管理",
                icon: "",
                menuId: "1-5",
                url: "/homepage/systemconfig/dictionary",
            },
            {
                parentName: "系统配置",
                moduleName: "模板文件",
                icon: "",
                menuId: "1-5",
                url: "/homepage/systemconfig/model-file",
            },
        ],
    },
    {
        moduleName: "项目配置",
        icon: "",
        menuId: "2",
        children: [
            // {
            //   parentName: "项目配置",
            //   moduleName: "生产配置",
            //   icon: "",
            //   menuId: "2-1",
            //   url: "/homepage/projectconfig/role"
            // },
            {
                parentName: "项目配置",
                moduleName: "告警配置",
                icon: "",
                menuId: "2-2",
                url: "/homepage/projectconfig/alarmsetting",
            },
            // {
            //   parentName: "项目配置",
            //   moduleName: "运营商管理",
            //   icon: "",
            //   menuId: "2-3",
            //   url: "/homepage/projectconfig/opr"
            // }
            // {
            //   parentName: "项目配置",
            //   moduleName: "系列型号",
            //   icon: "",
            //   menuId: "2-4",
            //   url: "/homepage/projectconfig/onlineuser"
            // },
            {
                parentName: "项目配置",
                moduleName: "费率管理",
                icon: "",
                menuId: "2-5",
                url: "/homepage/projectconfig/ratamanage",
            },
        ],
    },
    {
        moduleName: "运维管理",
        icon: "",
        menuId: "3",
        children: [
            // {
            //   parentName: "运维管理",
            //   moduleName: "设备管理",
            //   icon: "",
            //   menuId: "3-1",
            //   url: "/maintenance/equipment"
            //   // url: "/systemconfig/log",
            // },
            // {
            //   parentName: "运维管理",
            //   moduleName: "SIM卡管理",
            //   icon: "",
            //   menuId: "3-2",
            //   url: "/maintenance/SIMCard"
            // },
            {
                parentName: "运维管理",
                moduleName: "告警管理",
                icon: "",
                menuId: "3-3",
                // url: "/maintenance/alarm/alarmQuery",
                children: [
                    {
                        parentName: "告警管理",
                        moduleName: "告警概览",
                        icon: "",
                        menuId: "3-3-1",
                        url: "/homepage/maintenance/alarm/summary",
                    },
                    {
                        parentName: "告警管理",
                        moduleName: "告警查询",
                        icon: "",
                        menuId: "3-3-2",
                        url: "/homepage/maintenance/alarm/query",
                    },
                    {
                        parentName: "告警管理",
                        moduleName: "事件告警",
                        icon: "",
                        menuId: "3-3-4",
                        url: "/homepage/maintenance/alarm/event",
                    },
                ],
            },
        ],
    },
    {
        moduleName: "设备管理",
        icon: "",
        menuId: "4",
        children: [
            {
                parentName: "设备管理",
                moduleName: "设备型号",
                icon: "",
                menuId: "4-1",
                url: "/homepage/equipment-manage/equipment-model",
            },
            {
                parentName: "设备管理",
                moduleName: "设备清单",
                icon: "",
                menuId: "4-2",
                url: "/homepage/equipment-manage/equipment-list",
            },
        ],
    },
    {
        moduleName: "运营商管理",
        icon: "",
        menuId: "5",
        url: "/homepage/operatormanage",
    },
    {
        moduleName: "生产管理",
        icon: "",
        menuId: "8",
        url: "/homepage/production",
        children: [
            {
                parentName: "生产管理",
                moduleName: "licence管理",
                icon: "",
                menuId: "8-1",
                url: "/homepage/production/card-client",
            },
            {
                parentName: "生产管理",
                moduleName: "出厂管理账号",
                icon: "",
                menuId: "8-2",
                url: "/homepage/production/factory-manage",
            },
        ],
    },
];
